module.exports = __webpack_public_path__ + "img/logo3.428193fa.png";